<template>
  <v-col class="history-transfer-ewallet">
    <ModalSearch ref="modalSearch" @action="cari"></ModalSearch>
    <ModalWithdraw ref="modalWithdrawal" @action="showOTP"></ModalWithdraw>
    <ModalOTP ref="modalOTP" @action="processWithdrawSaldo"></ModalOTP>

    <div class="d-flex justify-space-between">
      <div class="text-h5 cl-primary">Pencairan Saldo komisi</div>
    </div>

    <div class="pt-1 pb-2 d-flex font-size-10 grey--text">
      <v-icon small color="grey">mdi-wallet</v-icon>
      <div class="pl-2">Saldo Wallet</div>
      <div class="px-2">/</div>
      <div>Pencairan Saldo Komisi</div>
    </div>

    <div class="mt-5">
      <v-row justify="space-between" class="align-center mb-5">
        <v-col cols="12" sm="6" md="4" xl="4" class="">
          <v-card class="pa-3 elevation-0 rounded-lg hover-shadow">
            <v-row class="align-start">
              <v-col cols="2" sm="2" md="2" class="pr-0 text-center">
                <img class="img-fluid" src="/assets/icon/saldo.png" />
              </v-col>
              <v-col cols="10" sm="9" md="9">
                <div class="font-size-14 blue--text font-weight-500">
                  {{ walletSummary | toRupiah }}
                </div>
                <div class="font-size-10 cl-grey">Total Saldo Komisi</div>

                <v-btn
                  color="info"
                  class="white--text rounded-lg text-capitalize mt-4"
                  @click="showWithdrawSaldo"
                  v-if="parseFloat(walletSummary) > 0"
                >
                  <v-icon dense class="mr-1">mdi-swap-vertical-bold</v-icon>
                  <span>Pencairan Saldo</span>
                </v-btn>
                <v-btn
                  disabled
                  color="info"
                  class="white--text rounded-lg text-capitalize mt-4"
                  v-else
                >
                  <v-icon dense class="mr-1">mdi-swap-vertical-bold</v-icon>
                  <span>Pencairan Saldo</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="6" class="py-0 py-sm-3">
          <div class="d-flex justify-end">
            <v-btn
              depressed
              color="primary"
              class="white--text rounded-lg text-capitalize"
              @click="showSearch"
            >
              <div class="d-flex">
                <v-icon small class="d-block d-sm-none">mdi-magnify</v-icon>
                <div class="d-none d-sm-block">Cari</div>
              </div>
            </v-btn>
            <v-btn
              depressed
              color="grey lighten-1"
              class="ml-3 white--text rounded-lg text-capitalize"
              @click="reset"
              >Reset</v-btn
            >
          </div>
        </v-col>
      </v-row>

      <div v-if="!loading">
        <v-row v-if="listWithdrawHistori.length > 0">
          <v-col cols="12" class="pt-0">
            <v-simple-table class="white-row table-vo table-vo-small table-history-bonus">
              <template v-slot:default>
                <thead class="">
                  <tr>
                    <th class="text-left" width="15%">Tanggal</th>
                    <th class="text-left" width="10%">Kode Transfer</th>
                    <th class="text-right" width="15%">Jml. Pencairan (Rp)</th>
                    <th class="text-right" width="10%">Biaya Admin</th>
                    <!-- <th class="text-right" width="10%">Pajak</th> -->
                    <th class="text-right" width="15%">Jml. Diterima (Rp)</th>
                    <th class="text-center" width="10%">Status</th>
                    <th class="text-left" width="25%">Catatan</th>
                  </tr>
                </thead>
                <tbody class="grey--text text--darken-3">
                  <tr
                    v-for="ewallet in listWithdrawHistori"
                    :key="ewallet.ewallet_withdrawal_id"
                  >
                    <td class="text-left">
                      {{ ewallet.ewallet_withdrawal_datetime | tanggaljam }}
                    </td>
                    <td class="text-left">
                      {{ ewallet.ewallet_withdrawal_transfer_code }}
                    </td>
                    <td class="text-right">
                      <div class="pa-1 cl-success font-weight-bold">
                        {{ ewallet.ewallet_withdrawal_value | toNumber }}
                      </div>
                    </td>
                    <td class="text-right">
                      <div class="pa-1 cl-error font-weight-bold">
                        {{ ewallet.ewallet_withdrawal_adm_charge_value | toNumber }}
                      </div>
                    </td>
                    <!-- <td class="text-right">
                      <div class="pa-1 cl-error font-weight-bold">
                        {{ ewallet.ewallet_withdrawal_tax_value | toNumber }}
                      </div>
                    </td> -->
                    <td class="text-right">
                      <div class="pa-1 green--text darken-3 font-weight-bold">
                        {{ ewallet.ewallet_withdrawal_nett | toNumber }}
                      </div>
                    </td>

                    <td class="text-center">
                      <v-chip
                        class="ma-2 py-2 w-100 text-center d-flex align-center justify-center font-weight-bold"
                        small
                        :color="generateStatusFlag(ewallet.ewallet_withdrawal_status)"
                        text-color="white"
                        style="opacity: 0.85; font-size: 85%"
                      >
                        {{ generateStatusText(ewallet.ewallet_withdrawal_status) }}
                      </v-chip>
                      <div class="pa-1 green--text darken-3 font-weight-bold"></div>
                    </td>

                    <td>
                      <b>{{ ewallet.ewallet_withdrawal_note }}</b
                      ><br />
                      <small class="d-block my-1" style="line-height: normal"
                        >Ditransfer via {{ ewallet.ewallet_withdrawal_bank_name }}<br />{{
                          ewallet.ewallet_withdrawal_bank_account_no
                        }}
                        ( a/n {{ ewallet.ewallet_withdrawal_bank_account_name }} )</small
                      >
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <div class="mt-3" v-if="listWithdrawHistori.length == 0">
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-card class="py-3 elevation-0 hover-shadow rounded-lg">
                <NoData></NoData>
                <div class="pt-3 text-center cl-secondary">
                  Tidak ada histori pencarian saldo komisi yang dapat ditampilkan
                </div>
              </v-card>
            </v-col>
          </v-row>
        </div>
        <div v-if="listWithdrawHistori.length > 0">
          <v-row justify="end">
            <v-col
              cols="12"
              sm="5"
              md="6"
              class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end"
            >
              <v-pagination
                v-model="page"
                total-visible="5"
                class="d-flex justify-end vo-pagination no-button-focus"
                color="primary"
                :length="historiWithdrawPagination.total_page"
                @input="changePage"
              ></v-pagination>
            </v-col>
            <v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
              <div class="font-size-10">
                Menampilkan {{ historiWithdrawPagination.total_display }} data dari total
                {{ historiWithdrawPagination.total_data }} data
              </div>
            </v-col>
            <v-col cols="4" sm="2" md="1">
              <v-autocomplete
                :items="listLimit"
                v-model="limit"
                hide-details
                dense
                class=""
                placeholder="Data"
                color="primary"
                @input="changeLimit"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </div>
      </div>
      <div class="mt-4" v-if="loading">
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <LoadData :loading="loading"></LoadData>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-col>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ModalSearch from "./components/ModalSearch";
import ModalWithdraw from "./components/withdrawForm";
import ModalOTP from "./components/ModalOTP";

export default {
  components: {
    ModalSearch,
    ModalWithdraw,
    ModalOTP,
  },
  data() {
    return {
      loading: false,
      startDate: false,
      dateStart: "",
      page: 1,
      limit: "10",
      listLimit: ["10", "20", "50", "100"],
      sort: "ewallet_withdrawal_datetime",
      dir: "DESC",
      params: [],
      passParams: null,
    };
  },
  computed: {
    ...mapState("ewallet", [
      "listWithdrawHistori",
      "historiWithdrawPagination",
      "walletSummary",
      "errorValidation",
    ]),
  },
  methods: {
    ...mapActions("ewallet", [
      "getHistoriWithdrawal",
      "getWalletSummary",
      "withdrawalWallet",
    ]),

    queryStringWithdrawHistory(value) {
      let parameterObject = {};
      let parameter = "{";

      if (value.params) {
        value.params.forEach((value, index) => {
          for (const [key, val] of Object.entries(value)) {
            parameter += `"filter[${index}][${key}]":"${val}",`;
          }
        });
      }
      // parameter += `"ewallet_product_transfer_sender_member_name": "${value.ewallet_product_transfer_sender_member_name}", "ewallet_product_transfer_receiver_member_name": "${value.ewallet_product_transfer_receiver_member_name}", "limit": "${value.limit}", "page": "${value.page}", "sort": "${value.sort}", "dir": "${value.dir}"`
      parameter += `"limit": "${value.limit}", "page": "${value.page}", "sort": "${value.sort}", "dir": "${value.dir}"`;
      parameter += "}";
      parameterObject = JSON.parse(parameter);
      return parameterObject;
    },

    async getData() {
      this.loading = await true;
      this.getWalletSummary().then(() => {
        // this.getHistoriWithdrawal(this.queryStringWithdrawHistory({ewallet_product_transfer_sender_member_name: '', ewallet_product_transfer_receiver_member_name: '', limit:this.limit, page: this.page, params: this.params, sort: this.sort, dir: this.dir})).then(() => {
        this.getHistoriWithdrawal(
          this.queryStringWithdrawHistory({
            limit: this.limit,
            page: this.page,
            params: this.params,
            sort: this.sort,
            dir: this.dir,
          })
        ).then(() => {
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
          this.loading = false;
        });
      });
    },

    generateStatusText(status) {
      if (status == "pending") return `Menunggu`;
      else if (status == "failed") return `Gagal`;
      else if (status == "processing") return `Diproses`;
      else if (status == "completed") return `Selesai`;
      else return `-`;
    },
    generateStatusFlag(status) {
      if (status == "pending") return `orange`;
      else if (status == "failed") return `red`;
      else if (status == "processing") return `primary`;
      else if (status == "completed") return `green`;
    },

    changePage(page) {
      this.page = page;
      this.getData();
    },

    changeLimit(limit) {
      this.limit = limit;
      this.page = 1;
      this.getData();
    },

    showSearch() {
      this.$refs.modalSearch.modalShow();
    },

    showWithdrawSaldo() {
      this.$refs.modalWithdrawal.modalShow();
    },

    reset() {
      this.page = 1;
      this.limit = "10";
      this.params = [];
      this.getData();
      this.$refs.modalSearch.reset();
    },

    cari(data) {
      this.params = [];
      this.page = 1;

      if (data.tfcode.value) this.params.push(data.tfcode);
      if (data.date.value) this.params.push(data.date);
      this.getHistoriWithdrawal(
        this.queryStringWithdrawHistory({
          limit: this.limit,
          page: this.page,
          params: this.params,
          sort: this.sort,
          dir: this.dir,
        })
      ).then(() => {
        this.$refs.modalSearch.modalHide();
      });
    },

    showOTP(params) {
      // this.serial_params.member_network_code = this.network_code
      // this.$refs.modalKonfirm.loadingButton()
      this.passParams = params;
      this.$refs.modalWithdrawal.modalHide();
      this.$refs.modalOTP.modalShow();
    },

    processWithdrawSaldo(data) {
      this.params = {};
      var that = this;

      if (this.passParams) {
        this.params = { balance: this.passParams.nominal.value, otp: data };
        this.withdrawalWallet(this.params)
          .then(() => {
            this.loading = true;

            this.page = 1;
            this.limit = "10";
            this.getHistoriWithdrawal(
              this.queryStringWithdrawHistory({
                limit: this.limit,
                page: this.page,
                params: this.params,
                sort: this.sort,
                dir: this.dir,
              })
            ).then(() => {
              that.getWalletSummary();
              // document.body.scrollTop = 0
              // document.documentElement.scrollTop = 0
              // this.loading = false
              location.reload();
            });

            setTimeout(() => {
              this.$refs.modalOTP.reset();
              this.$refs.modalOTP.modalHide();
              this.loading = false;
            }, 1000);
          })
          .catch(() => {
            this.$refs.modalOTP.stopLoading();
            this.loading = false;
          });
      }
    },
  },

  created() {
    this.$store.dispatch("setPageTitle", `Pencairan Saldo Komisi`);
    this.getData();
  },
};
</script>
